define('models/validator/cardlinkednickname',["backbone",
        "models/validator/length"
], function (Backbone, LengthValidator) {
    "use strict";

    return LengthValidator.extend({

        defaults: {
            validationType: enums.validationType.nameFirst,
            minLength: 1,
            maxLength: 24,
        },

        validate: function(val) {
            this.set('value', val);
            var code = this.validateHasValue(val);
            if ( this.isValid(code) ) {
                code = this.validateLength(val, this.get('minLength'), this.get('maxLength'))
            }
            this.set('validationCode', code);
            return code;
        }
    });
});
